import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class DigitalLectureFilterOption extends BaseModel {
  static override constructorName = 'DigitalLectureFilterOption'

  id: number = 0
  name: string = ''
  isActive: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(DigitalLectureFilterOption)
